import { Chip } from '../primitives/Chip'

/** Shown whenever a screen is drawn from example data. <Screen> adds it from `data.example`; you rarely place it. */
export function ExampleChip() {
  return (
    <Chip tone="outline" title="Shopify isn't connected yet, so this shows made-up numbers.">
      Example data
    </Chip>
  )
}
